import config from "@/config.js";
export function checkTimeout() {
    let timer = localStorage.getItem(config.TIMER);
    const millis = Date.now() - timer;
    let difference = Math.floor(millis / 1000);
    if (difference > config.TIMEOUT) {
      return true;
    } else {
        return false;
    }
}

export function setTimeout(time) {
    localStorage.setItem(config.TIMER, time);
}

export function getFhirClientId(jwt) {
    var tokens = jwt.split(".");
    const decodedValue = JSON.parse(Buffer.from(tokens[1], 'base64').toString('ascii'));
    return decodedValue.client_id;
}